import axios from "axios";

var backendDomain = "https://api-dot-erpmvpproduction.de.r.appspot.com";
// backendDomain = "http://localhost:8000";
// backendDomain = "https://landl-erp-server.herokuapp.com";

export default axios.create({
  baseURL: backendDomain,
});
